module.exports = __webpack_public_path__ + "static/botsProds-699224a3d73ba3405deef43de98a4cbe.png";